// src/app/core/services/loading.service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCount = 0;
  public isLoading = signal<boolean>(false);

  /**
   * Iniciar carga
   */
  show() {
    this.loadingCount++;
    this.isLoading.set(true);
  }

  /**
   * Detener carga
   */
  hide() {
    this.loadingCount--;
    if (this.loadingCount <= 0) {
      this.loadingCount = 0;
      this.isLoading.set(false);
    }
  }

  /**
   * Forzar detener todas las cargas
   */
  forceHide() {
    this.loadingCount = 0;
    this.isLoading.set(false);
  }
}